import { useEffect } from 'react';

const useUnloadPagePrompt = (hasChanges?: boolean) => {
  useEffect(() => {
    if (hasChanges) {
      const onUnloadPrompt = (e) => {
        e.preventDefault();
        // Needs to be set to display the prompt in all browsers. Otherwise prompt will not appear.
        e.returnValue = '';
      };

      window.addEventListener('beforeunload', onUnloadPrompt);

      return () => window.removeEventListener('beforeunload', onUnloadPrompt);
    }
  }, [hasChanges]);
};

export default useUnloadPagePrompt;
